import { useFindByQuery } from '../../graphql';

export const useFeatures = () => {
  const { data, isLoading, isFetching, isError, error, refetch } =
    useFindByQuery({
      modelName: 'feature',
      query: GET_FEATURES,
    });

  return { data, isLoading, isFetching, isError, error, refetch };
};

export const GET_FEATURES = `
  query findFeatures {
    findFeatures {
      items {
        id
        name
        enabled
        description
        workspaces {
          id
        }
        accounts {
          id
        }
      }
    }
  }
`;
